import {
  FaArrowUp,
  FaBalanceScale,
  FaBook,
  FaBroom,
  FaBriefcase,
  FaBuilding,
  FaCalculator,
  FaCertificate,
  FaChartBar,
  FaChartLine,
  FaChartPie,
  FaCoins,
  FaCreditCard,
  FaEnvelopeOpenText,
  FaExchangeAlt,
  FaFemale,
  FaBullhorn,
  FaFileInvoice,
  FaFileInvoiceDollar,
  FaFileSignature,
  FaFire,
  FaGasPump,
  FaGraduationCap,
  FaHandshake,
  FaHandHoldingHeart,
  FaHome,
  FaHome as FaHouse,
  FaIdBadge,
  FaKey,
  FaLayerGroup,
  FaMoneyBillWave,
  FaPercent,
  FaPills,
  FaPiggyBank,
  FaReceipt,
  FaRupeeSign,
  FaSeedling,
  FaShieldAlt,
  FaStore,
  FaShoppingBag,
  FaTaxi,
  FaTint,
  FaBullseye,
  FaUmbrella,
  FaUniversity,
  FaUserShield,
  FaUserTie,
  FaUsers,
  FaUtensils,
  FaWifi,
} from 'react-icons/fa';

export const CUSTOM_FAQ_PATHS = ['/', '/emi', '/sip', '/income-tax', '/gst'];

export const ROUTE_LABELS = {
  '/': 'Home',
  '/blog': 'Blog',
  '/emi': 'EMI Calculator',
  '/loan-prepayment': 'Loan Prepayment Calculator',
  '/home-loan-eligibility': 'Home Loan Eligibility Calculator',
  '/loan-estimator': 'Customer Loan Estimator',
  '/lic-plan': 'LIC Plan Calculator',
  '/sip': 'SIP Calculator',
  '/lumpsum': 'Lumpsum Calculator',
  '/goal-sip': 'Goal SIP Planner',
  '/swp': 'SWP Calculator',
  '/elss': 'ELSS Tax Saver Calculator',
  '/fd': 'FD Calculator',
  '/rd': 'RD Calculator',
  '/ppf': 'PPF Calculator',
  '/epf': 'EPF Calculator',
  '/nps': 'NPS Calculator',
  '/retirement': 'Retirement Planner',
  '/fire': 'FIRE Calculator',
  '/fixed-income': 'Fixed Monthly Income Calculator',
  '/gratuity': 'Gratuity Calculator',
  '/income-tax': 'Income Tax Calculator',
  '/gst': 'GST Calculator',
  '/hra': 'HRA Calculator',
  '/tds': 'TDS Calculator',
  '/tds-rent': 'TDS on Rent Calculator',
  '/professional-tax': 'Professional Tax Calculator',
  '/capital-gain': 'Capital Gain Tax Calculator',
  '/stamp-duty': 'Stamp Duty Calculator',
  '/rent-vs-buy': 'Rent vs Buy Calculator',
  '/rental-yield': 'Rental Yield Calculator',
  '/water-storage': 'Water Storage Calculator',
  '/salary': 'Salary Calculator',
  '/invoice': 'Invoice Generator',
  '/business-poster': 'Business Poster Generator',
  '/restaurant-menu-generator': 'Restaurant Menu Generator',
  '/group-collection-report': 'Event Fund Report',
  '/markup': 'Markup and Margin Calculator',
  '/breakeven': 'Break-even Analysis Calculator',
  '/general-bill': 'General Bill Generator',
  '/shop-bill': 'Shop Bill Generator',
  '/quotation': 'Quotation Generator',
  '/rent-receipt': 'Rent Receipt Generator',
  '/salary-slip': 'Salary Slip Generator',
  '/petrol-bill': 'Fuel Bill Generator',
  '/restaurant-bill': 'Restaurant Bill Generator',
  '/medical-bill': 'Medical Bill Generator',
  '/internet-bill': 'Internet Bill Generator',
  '/cab-bill': 'Cab Bill Generator',
  '/daily-helper-bill': 'Daily Helper Bill Generator',
  '/library-book-receipt': 'Library Book Receipt Generator',
  '/school-fees-receipt': 'School Fees Receipt Generator',
  '/simple-interest': 'Simple Interest Calculator',
  '/compound-interest': 'Compound Interest Calculator',
  '/inflation': 'Inflation Calculator',
  '/stock-profit': 'Stock Profit Calculator',
  '/cagr': 'CAGR Calculator',
  '/dividend-yield': 'Dividend Yield Calculator',
  '/stock-average': 'Stock Average Calculator',
  '/mf-returns': 'Mutual Fund Returns Calculator',
  '/ecommerce-profit': 'E-commerce Profit Calculator',
  '/ssy': 'SSY Calculator',
  '/nsc': 'NSC Calculator',
  '/kvp': 'KVP Calculator',
  '/scss': 'SCSS Calculator',
  '/pomis': 'POMIS Calculator',
  '/potd': 'Post Office TD Calculator',
  '/pmvvy': 'PMVVY Calculator',
  '/apy': 'APY Calculator',
};

export const ROUTE_DESCRIPTIONS = {
  '/blog': 'Read practical finance guides linked to useful tools.',
  '/emi': 'Compare monthly loan cost, interest burden, and repayment schedule.',
  '/loan-prepayment': 'See how part-payments can reduce tenure or interest.',
  '/home-loan-eligibility': 'Estimate how much housing loan you may qualify for.',
  '/loan-estimator': 'Estimate EMI, repayment burden, and an affordable loan amount for personal, car, and home loans.',
  '/lic-plan': 'Estimate LIC premium outgo, bonus, maturity value, and expected returns for savings-oriented plans.',
  '/sip': 'Project long-term wealth from disciplined monthly investing.',
  '/lumpsum': 'Check one-time investment growth with compounding.',
  '/goal-sip': 'Estimate the SIP needed for a target financial goal.',
  '/swp': 'Plan monthly withdrawals from your investment corpus.',
  '/elss': 'Blend tax saving with long-term equity investing.',
  '/fd': 'Estimate maturity value for fixed deposits.',
  '/rd': 'Project recurring deposit growth over time.',
  '/ppf': 'Estimate long-term provident fund corpus under PPF.',
  '/epf': 'Plan employee provident fund growth over working years.',
  '/nps': 'Project retirement corpus and pension under NPS.',
  '/retirement': 'Estimate how much corpus you need for retirement.',
  '/fire': 'Model financial independence and early retirement goals.',
  '/fixed-income': 'Estimate corpus needed for monthly income targets.',
  '/gratuity': 'Calculate gratuity entitlement from salary and service.',
  '/income-tax': 'Compare tax liability across regimes and deductions.',
  '/gst': 'Add or remove GST and inspect tax split quickly.',
  '/hra': 'Estimate HRA exemption for salaried taxpayers.',
  '/tds': 'Estimate TDS on salary, fees, and other payments.',
  '/tds-rent': 'Check rent withholding impact under applicable rules.',
  '/professional-tax': 'Review state-level professional tax deductions.',
  '/capital-gain': 'Estimate tax impact before booking gains.',
  '/stamp-duty': 'Estimate property registration and stamp charges.',
  '/rent-vs-buy': 'Compare ownership cost with renting outcomes.',
  '/rental-yield': 'Measure gross and net property income yield.',
  '/water-storage': 'Calculate water tank storage in liters using tank dimensions and water height.',
  '/salary': 'Estimate take-home pay from salary structure inputs.',
  '/invoice': 'Create a structured client-ready invoice document.',
  '/business-poster': 'Design polished promotional posters for sales, events, and local business offers.',
  '/restaurant-menu-generator': 'Design polished restaurant menus with multiple templates, sections, and instant image export.',
  '/group-collection-report': 'Track grouped contributions, event expenses, and fair share distribution for pujas, parties, and get-togethers.',
  '/markup': 'Compare markup, margin, and pricing outcomes.',
  '/breakeven': 'Find the sales level needed to avoid losses.',
  '/general-bill': 'Generate flexible bills, receipts, and service docs.',
  '/shop-bill': 'Create grocery bills and retail shop bills with itemized totals and PDF export.',
  '/quotation': 'Prepare itemized quotations with pricing and taxes.',
  '/rent-receipt': 'Create HRA-style rent receipts with landlord details.',
  '/salary-slip': 'Generate printable salary slips with deductions.',
  '/petrol-bill': 'Create fuel bills with quantity, rate, and totals.',
  '/restaurant-bill': 'Prepare dining bills with GST and service charge.',
  '/medical-bill': 'Create hospital or pharmacy-style billing output.',
  '/internet-bill': 'Generate broadband or ISP bill formats quickly.',
  '/cab-bill': 'Create ride, taxi, or cab billing documents.',
  '/daily-helper-bill': 'Prepare salary and attendance-based helper bills.',
  '/library-book-receipt': 'Create library issue, return, or fine receipts.',
  '/school-fees-receipt': 'Generate school fee receipts with multiple heads.',
  '/simple-interest': 'Calculate non-compounding interest outcomes.',
  '/compound-interest': 'Estimate reinvested growth over time.',
  '/inflation': 'Measure future purchasing power impact of inflation.',
  '/stock-profit': 'Estimate trade profit or loss after charges.',
  '/cagr': 'Measure annualized growth rate across time.',
  '/dividend-yield': 'Compare income yield from dividend-paying stocks.',
  '/stock-average': 'Calculate average acquisition cost across buys.',
  '/mf-returns': 'Project mutual fund returns for SIP or lumpsum cases.',
  '/ecommerce-profit': 'Estimate marketplace selling profit for Flipkart, Amazon India, and Meesho.',
  '/ssy': 'Estimate returns for Sukanya Samriddhi contributions.',
  '/nsc': 'Estimate National Savings Certificate maturity.',
  '/kvp': 'Project Kisan Vikas Patra value growth.',
  '/scss': 'Estimate senior citizen scheme maturity and income.',
  '/pomis': 'Check monthly income under POMIS assumptions.',
  '/potd': 'Estimate post office time deposit value.',
  '/pmvvy': 'Review pension-style return under PMVVY assumptions.',
  '/apy': 'Estimate pension contribution needs under APY.',
};

export const ROUTE_ICONS = {
  '/blog': FaBook,
  '/emi': FaMoneyBillWave,
  '/loan-prepayment': FaMoneyBillWave,
  '/home-loan-eligibility': FaHome,
  '/loan-estimator': FaCalculator,
  '/lic-plan': FaHandHoldingHeart,
  '/sip': FaChartLine,
  '/lumpsum': FaPiggyBank,
  '/goal-sip': FaBullseye,
  '/swp': FaExchangeAlt,
  '/elss': FaShieldAlt,
  '/fd': FaUniversity,
  '/rd': FaBuilding,
  '/ppf': FaPiggyBank,
  '/epf': FaUserTie,
  '/nps': FaUserTie,
  '/retirement': FaUmbrella,
  '/fire': FaFire,
  '/fixed-income': FaMoneyBillWave,
  '/gratuity': FaReceipt,
  '/income-tax': FaPercent,
  '/gst': FaReceipt,
  '/hra': FaBuilding,
  '/tds': FaRupeeSign,
  '/tds-rent': FaHouse,
  '/professional-tax': FaBriefcase,
  '/capital-gain': FaChartLine,
  '/stamp-duty': FaCertificate,
  '/rent-vs-buy': FaHandshake,
  '/rental-yield': FaChartBar,
  '/water-storage': FaTint,
  '/salary': FaFileInvoiceDollar,
  '/invoice': FaFileInvoice,
  '/business-poster': FaBullhorn,
  '/restaurant-menu-generator': FaUtensils,
  '/group-collection-report': FaUsers,
  '/markup': FaStore,
  '/breakeven': FaBalanceScale,
  '/general-bill': FaReceipt,
  '/shop-bill': FaShoppingBag,
  '/quotation': FaFileSignature,
  '/rent-receipt': FaFileInvoice,
  '/salary-slip': FaIdBadge,
  '/petrol-bill': FaGasPump,
  '/restaurant-bill': FaUtensils,
  '/medical-bill': FaPills,
  '/internet-bill': FaWifi,
  '/cab-bill': FaTaxi,
  '/daily-helper-bill': FaBroom,
  '/library-book-receipt': FaBook,
  '/school-fees-receipt': FaGraduationCap,
  '/simple-interest': FaCalculator,
  '/compound-interest': FaCalculator,
  '/inflation': FaArrowUp,
  '/stock-profit': FaBalanceScale,
  '/cagr': FaChartLine,
  '/dividend-yield': FaCoins,
  '/stock-average': FaLayerGroup,
  '/mf-returns': FaChartPie,
  '/ecommerce-profit': FaStore,
  '/ssy': FaFemale,
  '/nsc': FaCertificate,
  '/kvp': FaSeedling,
  '/scss': FaUserShield,
  '/pomis': FaEnvelopeOpenText,
  '/potd': FaUniversity,
  '/pmvvy': FaHandHoldingHeart,
  '/apy': FaUmbrella,
};

export const ROUTE_COLORS = {
  '/blog': '#0f766e',
  '/emi': '#2563eb',
  '/loan-prepayment': '#7c3aed',
  '/home-loan-eligibility': '#0891b2',
  '/sip': '#10b981',
  '/lumpsum': '#f59e0b',
  '/goal-sip': '#f97316',
  '/swp': '#14b8a6',
  '/elss': '#22c55e',
  '/fd': '#f97316',
  '/rd': '#6366f1',
  '/ppf': '#8b5cf6',
  '/epf': '#ec4899',
  '/nps': '#14b8a6',
  '/retirement': '#0ea5e9',
  '/fire': '#f97316',
  '/income-tax': '#ef4444',
  '/gst': '#a855f7',
  '/capital-gain': '#dc2626',
  '/invoice': '#7c3aed',
  '/business-poster': '#f43f5e',
  '/group-collection-report': '#8b5cf6',
  '/quotation': '#1d4ed8',
  '/general-bill': '#1d4ed8',
  '/rent-receipt': '#0ea5e9',
};

export const ROUTE_GROUPS = {
  loans: ['/emi', '/loan-prepayment', '/home-loan-eligibility', '/loan-estimator', '/rent-vs-buy', '/stamp-duty'],
  insurance: ['/lic-plan', '/pmvvy'],
  investing: ['/sip', '/lumpsum', '/goal-sip', '/swp', '/mf-returns', '/cagr', '/stock-average', '/dividend-yield', '/stock-profit'],
  retirement: ['/ppf', '/epf', '/nps', '/retirement', '/fire', '/fixed-income', '/gratuity'],
  tax: ['/income-tax', '/gst', '/hra', '/tds', '/tds-rent', '/professional-tax', '/capital-gain', '/elss'],
  savingsSchemes: ['/ssy', '/nsc', '/kvp', '/scss', '/pomis', '/potd', '/pmvvy', '/apy'],
  business: ['/salary', '/invoice', '/business-poster', '/group-collection-report', '/markup', '/breakeven', '/ecommerce-profit', '/quotation', '/general-bill', '/shop-bill', '/salary-slip'],
  bills: ['/rent-receipt', '/petrol-bill', '/restaurant-bill', '/medical-bill', '/internet-bill', '/cab-bill', '/daily-helper-bill', '/library-book-receipt', '/school-fees-receipt'],
  interest: ['/simple-interest', '/compound-interest', '/inflation'],
  realEstate: ['/rent-vs-buy', '/rental-yield', '/home-loan-eligibility', '/stamp-duty'],
  waterTools: ['/water-storage'],
};

export const DOCUMENT_SUBGROUPS = {
  receipts: ['/rent-receipt', '/library-book-receipt', '/school-fees-receipt'],
  payroll: ['/salary-slip', '/daily-helper-bill'],
  hospitality: ['/restaurant-bill', '/cab-bill', '/medical-bill', '/internet-bill', '/petrol-bill'],
  quotations: ['/quotation', '/invoice', '/general-bill'],
};

export const BLOG_RECOMMENDATIONS = ['/income-tax', '/sip', '/emi', '/blog'];
export const HOME_RECOMMENDATIONS = ['/emi', '/sip', '/income-tax', '/general-bill'];

export const ROUTE_RECOMMENDATION_OVERRIDES = {
  '/emi': ['/loan-prepayment', '/home-loan-eligibility', '/rent-vs-buy'],
  '/loan-prepayment': ['/emi', '/home-loan-eligibility', '/fixed-income'],
  '/home-loan-eligibility': ['/emi', '/loan-prepayment', '/stamp-duty'],
  '/loan-estimator': ['/emi', '/home-loan-eligibility', '/loan-prepayment'],
  '/lic-plan': ['/pmvvy', '/retirement', '/nps'],
  '/sip': ['/goal-sip', '/mf-returns', '/lumpsum'],
  '/lumpsum': ['/sip', '/cagr', '/mf-returns'],
  '/ppf': ['/epf', '/nps', '/retirement'],
  '/nps': ['/retirement', '/fire', '/fixed-income'],
  '/income-tax': ['/hra', '/tds', '/elss'],
  '/gst': ['/invoice', '/quotation', '/general-bill'],
  '/capital-gain': ['/stock-profit', '/cagr', '/mf-returns'],
  '/ecommerce-profit': ['/markup', '/breakeven', '/gst'],
  '/rent-vs-buy': ['/home-loan-eligibility', '/stamp-duty', '/rental-yield'],
  '/rental-yield': ['/rent-vs-buy', '/stamp-duty', '/home-loan-eligibility'],
  '/water-storage': ['/internet-bill', '/general-bill', '/rent-vs-buy'],
  '/invoice': ['/quotation', '/general-bill', '/gst'],
  '/business-poster': ['/invoice', '/quotation', '/shop-bill'],
  '/group-collection-report': ['/invoice', '/general-bill', '/business-poster'],
  '/quotation': ['/invoice', '/general-bill', '/markup'],
  '/general-bill': ['/invoice', '/quotation', '/gst'],
  '/shop-bill': ['/general-bill', '/quotation', '/gst'],
  '/rent-receipt': ['/salary', '/hra', '/income-tax'],
  '/salary-slip': ['/salary', '/professional-tax', '/income-tax'],
  '/medical-bill': ['/general-bill', '/gst', '/quotation'],
  '/simple-interest': ['/compound-interest', '/fd', '/rd'],
  '/compound-interest': ['/simple-interest', '/sip', '/lumpsum'],
  '/inflation': ['/retirement', '/goal-sip', '/fixed-income'],
  '/stock-profit': ['/capital-gain', '/cagr', '/dividend-yield'],
  '/dividend-yield': ['/stock-profit', '/stock-average', '/cagr'],
  '/markup': ['/breakeven', '/ecommerce-profit', '/gst'],
  '/breakeven': ['/markup', '/ecommerce-profit', '/gst'],
  '/blog': ['/income-tax', '/sip', '/emi'],
};

export const ROUTE_FAQ_OVERRIDES = {
  '/ppf': [
    { question: 'What does the PPF Calculator estimate?', answer: 'The PPF Calculator estimates how your yearly contributions can grow over the account term using the expected Public Provident Fund interest assumptions.' },
    { question: 'Can I use this for long-term tax-saving planning?', answer: 'Yes. This tool is useful for long-term 80C planning and understanding the compounding effect of disciplined yearly deposits.' },
    { question: 'Do actual PPF interest rates stay fixed forever?', answer: 'No. PPF rates can be revised by the government, so you should verify the latest official rate before making final projections.' },
    { question: 'Is the PPF Calculator useful for maturity planning?', answer: 'Yes. It helps estimate maturity value and compare different annual contribution amounts over time.' },
  ],
  '/nps': [
    { question: 'What can the NPS Calculator help me plan?', answer: 'The NPS Calculator helps you estimate retirement corpus, annuity allocation, and possible pension outcomes based on your contribution pattern and return assumptions.' },
    { question: 'Does NPS final value depend on market performance?', answer: 'Yes. NPS outcomes depend on actual market-linked returns, asset allocation, and contribution duration, so the result is an estimate, not a guarantee.' },
    { question: 'Can I use this for retirement income planning?', answer: 'Yes. It is useful for estimating how much corpus and annuity-based income NPS may support at retirement.' },
    { question: 'Should I verify withdrawal and annuity rules separately?', answer: 'Yes. NPS withdrawal, tax, and annuity rules can change, so confirm the latest official framework before making final decisions.' },
  ],
  '/fire': [
    { question: 'What does the FIRE Calculator measure?', answer: 'The FIRE Calculator estimates the corpus you may need to reach financial independence and potentially retire early based on expenses, savings, and return assumptions.' },
    { question: 'Why are annual expenses important in FIRE planning?', answer: 'Your expected annual expenses largely determine the corpus needed for financial independence, so realistic spending estimates matter a lot.' },
    { question: 'Is FIRE planning only about high returns?', answer: 'No. FIRE depends on savings rate, expense control, time horizon, inflation, and withdrawal discipline, not just investment returns.' },
    { question: 'Should I stress-test my FIRE assumptions?', answer: 'Yes. You should test lower returns, higher inflation, and changing lifestyle needs before relying on an early-retirement plan.' },
  ],
  '/capital-gain': [
    { question: 'What does the Capital Gain Tax Calculator estimate?', answer: 'The Capital Gain Tax Calculator estimates taxable gains and likely tax impact for assets such as stocks, mutual funds, real estate, or gold based on your entries.' },
    { question: 'Does holding period affect capital gains tax?', answer: 'Yes. Short-term and long-term treatment can differ significantly, so holding period is a major factor in the tax result.' },
    { question: 'Can I use this tool for tax planning before selling?', answer: 'Yes. It is useful for scenario comparison before booking gains or deciding when to exit an asset.' },
    { question: 'Should I verify asset-specific tax rules separately?', answer: 'Yes. Capital gains rules can vary by asset type and financial year, so confirm the applicable law before filing or selling.' },
  ],
  '/tds': [
    { question: 'What is the TDS Calculator used for?', answer: 'The TDS Calculator helps estimate tax deducted at source on different types of income or payments using the entered rate and amount assumptions.' },
    { question: 'Can TDS differ by payment type?', answer: 'Yes. TDS rates and thresholds may vary for salary, professional fees, rent, interest, and other categories.' },
    { question: 'Is TDS the same as final tax liability?', answer: 'No. TDS is usually a withholding mechanism and may differ from your final tax payable or refundable amount after return filing.' },
    { question: 'Should I check the latest thresholds before using final numbers?', answer: 'Yes. Always verify current TDS sections, exemptions, and limits from official sources before relying on the final figure.' },
  ],
  '/tds-rent': [
    { question: 'What does the TDS on Rent Calculator help with?', answer: 'It helps estimate TDS obligations on rent payments based on the applicable section, amount, and threshold assumptions.' },
    { question: 'Do all rent payments attract TDS?', answer: 'No. TDS on rent depends on thresholds, payer type, and the relevant section, so not every rent payment requires deduction.' },
    { question: 'Can this tool help before entering a rent arrangement?', answer: 'Yes. It is useful for checking likely withholding impact before committing to a rent structure or monthly payment amount.' },
    { question: 'Should I confirm the applicable section separately?', answer: 'Yes. You should confirm whether Section 194I, 194IB, or another rule applies before acting on the estimate.' },
  ],
  '/home-loan-eligibility': [
    { question: 'What does the Home Loan Eligibility Calculator estimate?', answer: 'The Home Loan Eligibility Calculator estimates how much loan you may qualify for based on income, existing obligations, tenure, and interest assumptions.' },
    { question: 'Does existing EMI affect home loan eligibility?', answer: 'Yes. Existing EMIs and fixed financial obligations can reduce the amount a lender may consider affordable for you.' },
    { question: 'Can I use this before speaking with a bank?', answer: 'Yes. It is useful for planning your price range and understanding affordability before starting a lender discussion.' },
    { question: 'Will the final bank approval match this exactly?', answer: 'No. Final approval can vary based on credit score, age, employment profile, documentation, lender policy, and property details.' },
  ],
  '/loan-estimator': [
    { question: 'What does the Customer Loan Estimator do?', answer: 'It estimates the EMI, repayment burden, eligible loan amount, and affordability gap for a customer based on income and existing EMIs.' },
    { question: 'Can I use it for personal, car, or business loans?', answer: 'Yes. It is a general-purpose loan estimator that can be used for most amortizing loans with a fixed interest rate and tenure.' },
    { question: 'Why does the affordability gap matter?', answer: 'It shows how far the requested loan amount is above or below the estimated safe borrowing limit.' },
    { question: 'Is this a lender approval decision?', answer: 'No. It is an estimate only. Final lending decisions depend on the bank or lender’s own checks and policies.' },
  ],
  '/lic-plan': [
    { question: 'What does the LIC Plan Calculator estimate?', answer: 'It estimates premium outgo, accrued bonus, maturity value, and expected returns for common LIC-style savings plans.' },
    { question: 'Is this an official LIC illustration?', answer: 'No. It is a planning estimate only. Actual LIC payouts depend on the specific policy, issue year, and declared bonuses.' },
    { question: 'Can I use this for money-back policies?', answer: 'Yes. The calculator includes a simplified money-back style estimate with periodic benefits and maturity value.' },
    { question: 'Should I verify the policy brochure separately?', answer: 'Yes. Always confirm plan features, guarantees, riders, and bonus assumptions from the official brochure or LIC illustration.' },
  ],
  '/rent-vs-buy': [
    { question: 'What does the Rent vs Buy Calculator compare?', answer: 'It compares the likely financial impact of renting versus buying by factoring in housing cost assumptions, ownership costs, and opportunity cost.' },
    { question: 'Should I include maintenance and upfront charges when buying?', answer: 'Yes. Stamp duty, registration, maintenance, furnishing, taxes, and financing costs can materially change the real cost of ownership.' },
    { question: 'Is renting always cheaper in the short term?', answer: 'Not always. The better option depends on tenure, appreciation, rent escalation, financing cost, and what you do with the capital you keep invested.' },
    { question: 'Can I compare multiple scenarios with this page?', answer: 'Yes. Change assumptions such as rent growth, property appreciation, down payment, and return on investments to compare different outcomes.' },
  ],
  '/rental-yield': [
    { question: 'What does the Rental Yield Calculator help me measure?', answer: 'The Rental Yield Calculator helps estimate the return generated by a property relative to its value and rental income.' },
    { question: 'Should I look at net yield instead of gross yield?', answer: 'Yes. Net yield is often more useful because maintenance, taxes, vacancy, and other expenses can significantly reduce actual returns.' },
    { question: 'Can this tool help compare two properties?', answer: 'Yes. You can enter different rent and property value assumptions to compare likely yield between options.' },
    { question: 'Is rental yield enough to judge an investment?', answer: 'No. You should also consider vacancy risk, appreciation potential, liquidity, legal clarity, and financing cost before investing.' },
  ],
  '/water-storage': [
    { question: 'What does the Water Storage Calculator estimate?', answer: 'It estimates tank water storage using dimensions and water height for rectangular or round tanks.' },
    { question: 'Can I calculate partial fill level?', answer: 'Yes. You can set fill level percentage and the calculator returns the effective storage in liters.' },
    { question: 'Can I use this for round water tanks?', answer: 'Yes. Round mode uses diameter and water height to calculate storage volume and liters.' },
    { question: 'Does this give exact real-world storage?', answer: 'It is a geometric estimate. Actual storage can vary slightly due to tank shape details and fittings.' },
  ],
  '/invoice': [
    { question: 'What can I create with the Invoice Generator?', answer: 'The Invoice Generator helps create a professional invoice with customer details, itemized charges, tax fields, totals, and printable output.' },
    { question: 'Can I use the invoice page for GST-ready billing?', answer: 'Yes. The page is designed to support structured invoice creation with GST-style fields and business billing details.' },
    { question: 'Can I customize line items and totals before download?', answer: 'Yes. You can edit item descriptions, quantities, pricing, taxes, and totals before generating the final invoice output.' },
    { question: 'Should I verify tax and business information before sending?', answer: 'Yes. Always confirm business name, GST details, tax rates, due dates, and total payable before issuing an invoice to a client.' },
  ],
  '/business-poster': [
    { question: 'What is the Business Poster Generator used for?', answer: 'The Business Poster Generator is used to create promotional social media posters, offer creatives, event announcements, and local business advertisements in a polished, printable format.' },
    { question: 'Can I customize text, colors, and design size?', answer: 'Yes. You can change brand name text, headline details, offer messaging, theme colors, poster size, and layout style to match your campaign.' },
    { question: 'Can I add my business logo to the poster?', answer: 'Yes. The poster editor lets you upload a logo and position it within the design so it feels more brand ready and professional.' },
    { question: 'Can I download the final poster as an image or PDF?', answer: 'Yes. You can export the final poster as a PNG image, save it as a PDF, or print it directly from the browser for sharing or offline use.' },
  ],
  '/rent-receipt': [
    { question: 'What is the Rent Receipt Generator used for?', answer: 'The Rent Receipt Generator helps create structured rent receipts with tenant, landlord, payment, and property details for record-keeping or submission.' },
    { question: 'Can I use this for HRA-related documentation?', answer: 'Yes. It is useful for preparing rent receipts that may support HRA-related record needs, subject to applicable employer and tax requirements.' },
    { question: 'Should I check landlord name, PAN, and rent period carefully?', answer: 'Yes. Rent receipts should be reviewed carefully for names, period, amount, address, and any required tax or identity details before use.' },
    { question: 'Can I print or save the generated rent receipt?', answer: 'Yes. The page is designed to help you create a clean receipt that can be downloaded, printed, or shared after review.' },
  ],
  '/salary-slip': [
    { question: 'What does the Salary Slip Generator create?', answer: 'The Salary Slip Generator helps create a structured payslip with salary components, deductions, net pay, and employee details in a printable format.' },
    { question: 'Can I include deductions like PF, ESI, and tax?', answer: 'Yes. The generator is useful for organizing common payroll deductions and presenting them clearly in the salary slip output.' },
    { question: 'Is this suitable for internal payroll record use?', answer: 'Yes. It is useful for creating clear salary documents for review, sharing, or internal record-keeping after proper verification.' },
    { question: 'Should payroll compliance be checked separately?', answer: 'Yes. You should verify statutory deductions, company policy, and employment compliance before using any generated salary slip officially.' },
  ],
  '/quotation': [
    { question: 'What can I prepare with the Quotation Generator?', answer: 'The Quotation Generator helps prepare a client-facing quotation with itemized pricing, taxes, validity details, and total payable values.' },
    { question: 'Can I customize quantities, pricing, and GST before download?', answer: 'Yes. You can edit quotation items, charges, taxes, and totals before generating the final document.' },
    { question: 'Is this useful for sending estimates to clients?', answer: 'Yes. It is designed to help create cleaner commercial estimates and quotations for sharing or printing.' },
    { question: 'Should I verify terms and tax details before sending?', answer: 'Yes. Always review quotation validity, pricing, GST details, and business information before sharing the final document externally.' },
  ],
  '/general-bill': [
    { question: 'What is the General Bill Generator meant for?', answer: 'The General Bill Generator helps create versatile bills such as invoices, receipts, sales bills, or service bills with editable item and tax details.' },
    { question: 'Can I use different currencies and tax modes here?', answer: 'Yes. The page is designed to support different billing structures, including varied currencies and tax modes depending on your use case.' },
    { question: 'Can I customize customer, business, and payment details?', answer: 'Yes. You can edit party details, line items, charges, notes, and payment information before generating the bill.' },
    { question: 'Should I review GST, VAT, or other billing compliance separately?', answer: 'Yes. If the bill is being used commercially, you should verify business identity, tax setup, and local compliance requirements before issuing it.' },
  ],
  '/shop-bill': [
    { question: 'What can I create with the Shop Bill Generator?', answer: 'You can create grocery bills and general shop bills with editable item lines, discount, tax, and a printable total.' },
    { question: 'Is it suitable for kirana or retail stores?', answer: 'Yes. It is designed for small retail shops, grocery stores, and similar point-of-sale billing needs.' },
    { question: 'Can I add or remove items before printing?', answer: 'Yes. You can add, edit, and remove items before generating the final bill.' },
    { question: 'Does it support PDF export and printing?', answer: 'Yes. The generator supports both PDF download and browser print for the final bill.' },
  ],
  '/school-fees-receipt': [
    { question: 'What does the School Fees Receipt Generator help create?', answer: 'The School Fees Receipt Generator helps create a structured school fee receipt with student details, fee heads, payment amounts, and balance information.' },
    { question: 'Can I include tuition, transport, hostel, and other fee heads?', answer: 'Yes. It is useful for organizing multiple fee components into a single receipt format before printing or saving.' },
    { question: 'Can I use this for parent-facing printable receipts?', answer: 'Yes. The generator is designed to produce clear receipts that can be printed or shared after verification.' },
    { question: 'Should I double-check student and payment details before issuing?', answer: 'Yes. Always verify student name, admission details, fee heads, paid amount, and balance before finalizing the receipt.' },
  ],
  '/medical-bill': [
    { question: 'What kind of document can I make with the Medical Bill Generator?', answer: 'The Medical Bill Generator helps create a pharmacy or hospital-style bill with patient details, itemized charges, taxes, and payment totals.' },
    { question: 'Can I include medicine or treatment line items?', answer: 'Yes. The generator is designed to organize line items, pricing, quantities, and other billing fields before creating the final document.' },
    { question: 'Is this useful for printable medical billing output?', answer: 'Yes. It is intended to help create clean, printable billing documents for review or record use.' },
    { question: 'Should I verify tax and regulatory details before official use?', answer: 'Yes. If the bill is used operationally, confirm medicine details, taxes, registration information, and local compliance requirements before issuing it.' },
  ],
  '/salary': [
    { question: 'What does the Salary Calculator estimate?', answer: 'The Salary Calculator helps estimate salary structure, deductions, take-home pay, and compensation breakdown based on the values you enter.' },
    { question: 'Can I use this tool to understand net take-home salary?', answer: 'Yes. It is useful for estimating how gross salary components and deductions may affect your final in-hand pay.' },
    { question: 'Can I compare different salary structures here?', answer: 'Yes. You can adjust components and deduction assumptions to compare multiple salary structure scenarios more clearly.' },
    { question: 'Should I verify payroll and tax details separately?', answer: 'Yes. Final salary, compliance, and tax treatment should always be cross-checked with your employer policy and official rules.' },
  ],
  '/markup': [
    { question: 'What does the Markup and Margin Calculator help me find?', answer: 'It helps you estimate selling price, markup, margin, and profit relationships so you can price products or services more accurately.' },
    { question: 'What is the difference between markup and margin?', answer: 'Markup is usually calculated on cost, while margin is usually calculated on selling price. This tool helps compare both clearly.' },
    { question: 'Can I use this for service pricing as well as products?', answer: 'Yes. It is useful for both product-based and service-based pricing decisions where you want a clearer profitability target.' },
    { question: 'Should I include indirect costs before final pricing?', answer: 'Yes. Overheads, taxes, discounts, and business operating costs should be considered before setting your final selling price.' },
  ],
  '/breakeven': [
    { question: 'What does the Break-even Analysis Calculator estimate?', answer: 'It estimates the sales level or unit volume needed to cover fixed and variable costs before a business starts generating profit.' },
    { question: 'Why is break-even analysis useful?', answer: 'It helps you understand the minimum revenue or quantity required to avoid losses and plan pricing or sales targets more realistically.' },
    { question: 'Can I use this to compare different pricing scenarios?', answer: 'Yes. You can adjust selling price, fixed cost, and variable cost assumptions to see how break-even changes under each scenario.' },
    { question: 'Is break-even enough to judge business success?', answer: 'No. Break-even is useful, but you should also consider cash flow, taxes, growth costs, seasonality, and demand stability.' },
  ],
  '/petrol-bill': [
    { question: 'What can I create with the Fuel Bill Generator?', answer: 'The Fuel Bill Generator helps create a structured petrol, diesel, or CNG bill with quantity, rate, amount, and station-related details.' },
    { question: 'Can I adjust quantity, rate, and total before download?', answer: 'Yes. You can edit the key billing values before generating the final output.' },
    { question: 'Is this useful for printable fuel bill output?', answer: 'Yes. It is intended to help create a readable, shareable fuel bill that can be saved or printed after review.' },
    { question: 'Should I verify tax and station details before final use?', answer: 'Yes. If the bill is used for record or reimbursement purposes, confirm the amount, date, and any required business details before sharing.' },
  ],
  '/restaurant-bill': [
    { question: 'What does the Restaurant Bill Generator create?', answer: 'The Restaurant Bill Generator helps create a food or dining bill with item details, GST split, service charge, and total payable values.' },
    { question: 'Can I include GST and service charge in the bill?', answer: 'Yes. The generator supports restaurant-style billing where taxes and service-related charges may need to be shown clearly.' },
    { question: 'Can I edit menu items and prices before finalizing?', answer: 'Yes. You can update line items, quantities, prices, and charge settings before generating the final bill output.' },
    { question: 'Should I review billing compliance before official use?', answer: 'Yes. If the bill is being used commercially, confirm pricing, taxes, and business information before issuing the final version.' },
  ],
  '/simple-interest': [
    { question: 'What does the Simple Interest Calculator estimate?', answer: 'The Simple Interest Calculator estimates interest earned or payable when interest is calculated only on the original principal amount.' },
    { question: 'How is simple interest different from compound interest?', answer: 'Simple interest is calculated only on the principal, while compound interest also includes interest earned on past interest over time.' },
    { question: 'Can I use this for loan or deposit comparisons?', answer: 'Yes. It is useful for quick comparisons where simple interest applies or where you want a basic non-compounding estimate.' },
    { question: 'Should I verify the actual product calculation method?', answer: 'Yes. Some financial products use compounding or additional charges, so the actual amount may differ from a simple-interest estimate.' },
  ],
  '/compound-interest': [
    { question: 'What does the Compound Interest Calculator help me estimate?', answer: 'It helps estimate how money grows over time when returns are reinvested and future growth happens on both principal and accumulated returns.' },
    { question: 'Why is compounding powerful over long periods?', answer: 'Compounding becomes more powerful over longer durations because each growth cycle builds on the previous one, increasing the final amount significantly.' },
    { question: 'Can I test different compounding frequencies here?', answer: 'Yes. Comparing annual, half-yearly, quarterly, or monthly compounding can help you understand how frequency affects final value.' },
    { question: 'Is this useful for savings and investment planning?', answer: 'Yes. It is a useful planning tool for understanding long-term growth potential across deposits, savings, and investments.' },
  ],
  '/inflation': [
    { question: 'What does the Inflation Calculator estimate?', answer: 'The Inflation Calculator estimates how purchasing power changes over time based on the inflation rate and time period you enter.' },
    { question: 'Why does inflation matter in financial planning?', answer: 'Inflation reduces the future buying power of money, which is why it matters for goals like retirement, education, and long-term savings.' },
    { question: 'Can I use this for future cost planning?', answer: 'Yes. It is useful for estimating what today’s amount may become in the future under different inflation assumptions.' },
    { question: 'Should I test multiple inflation assumptions?', answer: 'Yes. Running conservative and higher inflation scenarios can help you avoid underestimating future financial needs.' },
  ],
  '/stock-profit': [
    { question: 'What does the Stock Profit Calculator measure?', answer: 'The Stock Profit Calculator estimates profit or loss from a stock trade after considering buy price, sell price, quantity, and applicable charges.' },
    { question: 'Does it help include brokerage and taxes?', answer: 'Yes. It is useful for understanding how charges such as brokerage and statutory costs affect your real profit or loss.' },
    { question: 'Can I use this before placing an exit order?', answer: 'Yes. It is useful for checking likely net profit or break-even outcomes before you sell.' },
    { question: 'Should I verify the exact broker charge structure separately?', answer: 'Yes. Actual charges can vary by broker, segment, and trade type, so confirm the exact pricing for final decisions.' },
  ],
  '/ecommerce-profit': [
    { question: 'What does the E-commerce Profit Calculator estimate?', answer: 'It estimates net profit or loss for marketplace sales on Flipkart, Amazon India, and Meesho after common charges and GST on fees.' },
    { question: 'Can I use this before listing a new product?', answer: 'Yes. It helps test selling price, quantity, and cost assumptions before you publish or promote a listing.' },
    { question: 'Are platform charges the same for all categories?', answer: 'No. Commission, fixed fees, and logistics charges can vary by category and fulfillment model, so this tool is for practical estimation.' },
    { question: 'What should I verify for final profitability?', answer: 'You should verify category-wise fees, returns, ad spend, and settlement reports from your seller dashboard before making final decisions.' },
  ],
  '/dividend-yield': [
    { question: 'What does the Dividend Yield Calculator estimate?', answer: 'The Dividend Yield Calculator estimates dividend yield by comparing expected annual dividend income with the current stock price or investment value.' },
    { question: 'Does a high dividend yield always mean a better stock?', answer: 'No. A high yield may look attractive, but you should also consider payout sustainability, business quality, and total return potential.' },
    { question: 'Can this help compare income-oriented stocks?', answer: 'Yes. It is useful for comparing likely dividend income between different stocks or investment amounts.' },
    { question: 'Should I verify dividend history before investing?', answer: 'Yes. Dividend policy, payout consistency, and business health should all be reviewed before relying on dividend income projections.' },
  ],
};

export const ROUTE_SEARCH_KEYWORDS = {
  '/emi': ['flat rate', 'floating rate', 'reducing balance', 'emi mode'],
  '/loan-prepayment': ['part payment', 'foreclosure', 'extra emi', 'pre-close'],
  '/home-loan-eligibility': ['loan eligibility', 'income based loan', 'max loan amount'],
  '/loan-estimator': ['personal loan', 'car loan', 'home loan', 'loan type'],
  '/sip': ['systematic investment plan', 'monthly investment', 'sip return'],
  '/lumpsum': ['one time investment', 'single investment', 'future value'],
  '/fd': ['fixed deposit', 'bank fd', 'maturity amount'],
  '/rd': ['recurring deposit', 'monthly deposit', 'rd maturity'],
  '/swp': ['systematic withdrawal plan', 'monthly withdrawal', 'retirement withdrawal'],
  '/goal-sip': ['goal planning', 'target corpus', 'monthly sip needed'],
  '/retirement': ['retirement corpus', 'retire early', 'pension planning'],
  '/fire': ['financial independence', 'retire early', 'fire number'],
  '/fixed-income': ['monthly income', 'fixed return', 'passive income'],
  '/lic-plan': ['premium', 'sum assured', 'policy maturity'],
  '/income-tax': ['old regime', 'new regime', 'tax slab', 'tax calculation'],
  '/gst': ['gst inclusive', 'gst exclusive', 'cgst sgst igst', 'tax invoice'],
  '/hra': ['house rent allowance', 'salary tax', 'hra exemption'],
  '/tds': ['tax deducted at source', 'tds rate', 'tds amount'],
  '/tds-rent': ['rent tds', 'section 194ib', 'landlord tds'],
  '/capital-gain': ['ltcg', 'stcg', 'capital gains tax', 'equity tax'],
  '/stamp-duty': ['property registration', 'registry charges', 'home buying charges'],
  '/rent-vs-buy': ['buy or rent', 'home purchase decision', 'property decision'],
  '/rental-yield': ['property yield', 'rent return', 'real estate return'],
  '/salary': ['ctc', 'in hand salary', 'gross to net', 'salary breakup'],
  '/invoice': ['bill format', 'tax invoice', 'customer invoice'],
  '/business-poster': ['business poster', 'promo poster', 'offer poster', 'poster maker'],
  '/restaurant-menu-generator': ['restaurant menu generator', 'restaurant menu template', 'cafe menu maker', 'food menu design', 'menu designer'],
  '/group-collection-report': ['group collection report', 'event fund report', 'party collection tracker', 'puja fund report', 'group event report', 'event money tracker', 'party expense report', 'puja contribution tracker'],
  '/markup': ['margin', 'selling price', 'cost price', 'profit margin'],
  '/breakeven': ['break even point', 'fixed cost', 'contribution margin'],
  '/ecommerce-profit': ['amazon', 'flipkart', 'meesho', 'platform fees', 'seller profit'],
  '/internet-bill': ['broadband', 'isp', 'plan', 'charges'],
  '/shop-bill': ['retail', 'items', 'billing', 'invoice'],
  '/petrol-bill': ['fuel receipt', 'diesel bill', 'petrol pump bill'],
  '/rent-receipt': ['house rent receipt', 'landlord receipt', 'hra proof'],
  '/restaurant-bill': ['food bill', 'dining receipt', 'gst food'],
  '/medical-bill': ['pharmacy bill', 'hospital bill', 'medicine receipt'],
  '/cab-bill': ['taxi bill', 'travel bill', 'trip receipt'],
  '/quotation': ['price quote', 'estimate', 'proposal'],
  '/library-book-receipt': ['book issue', 'library slip', 'book return'],
  '/daily-helper-bill': ['maid salary', 'helper charges', 'domestic help'],
  '/water-storage': ['tank', 'rectangle tank', 'round tank', 'liters', 'fill level'],
  '/salary-slip': ['earnings', 'deductions', 'payslip'],
  '/general-bill': ['receipt', 'charges', 'tax'],
  '/school-fees-receipt': ['tuition fee', 'school payment', 'fees receipt'],
  '/simple-interest': ['si', 'principal rate time', 'simple return'],
  '/compound-interest': ['ci', 'compound growth', 'compounding'],
  '/inflation': ['purchasing power', 'future cost', 'price rise'],
  '/stock-profit': ['share profit', 'stock gain', 'stock loss'],
  '/cagr': ['annualized return', 'growth rate', 'investment growth'],
  '/dividend-yield': ['dividend return', 'income stock', 'yield percentage'],
  '/stock-average': ['average buying price', 'averaging down', 'stock average price'],
  '/mf-returns': ['mutual fund return', 'xirr', 'mf performance'],
};

export const SIDEBAR_MENU_ITEMS = [
  { path: '/', icon: FaHome, label: 'Home' },
  { path: '/blog', icon: FaBook, label: 'Blog' },
  { category: 'Loan Calculators', items: [
    { path: '/emi', icon: FaMoneyBillWave, label: 'EMI Calculator' },
    { path: '/loan-prepayment', icon: FaCreditCard, label: 'Loan Prepayment' },
    { path: '/home-loan-eligibility', icon: FaKey, label: 'Home Loan Eligibility' },
    { path: '/loan-estimator', icon: FaCalculator, label: 'Customer Loan Estimator' },
  ] },
  { category: 'Investment Calculators', items: [
    { path: '/sip', icon: FaChartLine, label: 'SIP Calculator' },
    { path: '/lumpsum', icon: FaPiggyBank, label: 'Lumpsum Calculator' },
    { path: '/fd', icon: FaUniversity, label: 'FD Calculator' },
    { path: '/rd', icon: FaBuilding, label: 'RD Calculator' },
    { path: '/swp', icon: FaExchangeAlt, label: 'SWP Calculator' },
    { path: '/goal-sip', icon: FaBullseye, label: 'Goal SIP Planner' },
    { path: '/elss', icon: FaShieldAlt, label: 'ELSS Tax Saver' },
  ] },
  { category: 'Govt Saving Schemes', items: [
    { path: '/ssy', icon: FaFemale, label: 'SSY (Sukanya Samriddhi)' },
    { path: '/nsc', icon: FaCertificate, label: 'NSC (National Savings)' },
    { path: '/kvp', icon: FaSeedling, label: 'KVP (Kisan Vikas Patra)' },
    { path: '/scss', icon: FaUserShield, label: 'SCSS (Senior Citizens)' },
    { path: '/pomis', icon: FaEnvelopeOpenText, label: 'POMIS (Monthly Income)' },
    { path: '/potd', icon: FaUniversity, label: 'Post Office TD' },
    { path: '/pmvvy', icon: FaHandHoldingHeart, label: 'PM Vaya Vandana' },
    { path: '/apy', icon: FaUmbrella, label: 'APY (Atal Pension)' },
  ] },
  { category: 'Retirement & FIRE', items: [
    { path: '/ppf', icon: FaPiggyBank, label: 'PPF Calculator' },
    { path: '/epf', icon: FaUserTie, label: 'EPF Calculator' },
    { path: '/nps', icon: FaUserTie, label: 'NPS Calculator' },
    { path: '/gratuity', icon: FaReceipt, label: 'Gratuity Calculator' },
    { path: '/retirement', icon: FaUmbrella, label: 'Retirement Planner' },
    { path: '/fire', icon: FaFire, label: 'FIRE Calculator' },
    { path: '/fixed-income', icon: FaMoneyBillWave, label: 'Fixed Monthly Income' },
  ] },
  { category: 'Insurance & Pension', items: [
    { path: '/lic-plan', icon: FaHandHoldingHeart, label: 'LIC Plan Calculator' },
    { path: '/pmvvy', icon: FaHandHoldingHeart, label: 'PM Vaya Vandana' },
  ] },
  { category: 'Tax Calculators', items: [
    { path: '/income-tax', icon: FaPercent, label: 'Income Tax Calculator' },
    { path: '/gst', icon: FaReceipt, label: 'GST Calculator' },
    { path: '/hra', icon: FaBuilding, label: 'HRA Calculator' },
    { path: '/tds', icon: FaRupeeSign, label: 'TDS Calculator' },
    { path: '/tds-rent', icon: FaHouse, label: 'TDS on Rent' },
    { path: '/professional-tax', icon: FaBriefcase, label: 'Professional Tax' },
    { path: '/capital-gain', icon: FaChartLine, label: 'Capital Gain Tax' },
  ] },
  { category: 'Real Estate', items: [
    { path: '/stamp-duty', icon: FaCertificate, label: 'Stamp Duty Calculator' },
    { path: '/rent-vs-buy', icon: FaHandshake, label: 'Rent vs Buy' },
    { path: '/rental-yield', icon: FaChartBar, label: 'Rental Yield' },
  ] },
  { category: 'Water Calculators', items: [
    { path: '/water-storage', icon: FaTint, label: 'Water Storage Calculator' },
  ] },
  { category: 'Salary & Business', items: [
    { path: '/salary', icon: FaFileInvoiceDollar, label: 'Salary Calculator' },
    { path: '/invoice', icon: FaFileInvoice, label: 'Invoice Generator' },
    { path: '/business-poster', icon: FaBullhorn, label: 'Business Poster Generator' },
    { path: '/restaurant-menu-generator', icon: FaUtensils, label: 'Restaurant Menu Generator' },
    { path: '/group-collection-report', icon: FaUsers, label: 'Event Fund Report' },
    { path: '/markup', icon: FaStore, label: 'Markup & Margin' },
    { path: '/breakeven', icon: FaBalanceScale, label: 'Break-even Analysis' },
    { path: '/ecommerce-profit', icon: FaStore, label: 'E-commerce Profit' },
    { path: '/shop-bill', icon: FaShoppingBag, label: 'Shop Bill Generator' },
    { path: '/petrol-bill', icon: FaGasPump, label: 'Fuel Bill Generator' },
    { path: '/rent-receipt', icon: FaFileInvoice, label: 'Rent Receipt Generator' },
    { path: '/restaurant-bill', icon: FaUtensils, label: 'Restaurant Bill Generator' },
    { path: '/salary-slip', icon: FaIdBadge, label: 'Salary Slip Generator' },
    { path: '/internet-bill', icon: FaWifi, label: 'Internet Bill Generator' },
    { path: '/medical-bill', icon: FaPills, label: 'Medical Bill (Pharmacy/Hospital)' },
    { path: '/cab-bill', icon: FaTaxi, label: 'Cab Bill Generator' },
    { path: '/quotation', icon: FaFileSignature, label: 'Quotation Generator' },
    { path: '/library-book-receipt', icon: FaBook, label: 'Library Book Receipt' },
    { path: '/daily-helper-bill', icon: FaBroom, label: 'Daily Helper Bill' },
    { path: '/general-bill', icon: FaReceipt, label: 'General Bill Generator' },
    { path: '/school-fees-receipt', icon: FaGraduationCap, label: 'School Fees Receipt' },
  ] },
  { category: 'Interest & Inflation', items: [
    { path: '/simple-interest', icon: FaCalculator, label: 'Simple Interest' },
    { path: '/compound-interest', icon: FaCalculator, label: 'Compound Interest' },
    { path: '/inflation', icon: FaArrowUp, label: 'Inflation Calculator' },
  ] },
  { category: 'Stock & MF Calculators', items: [
    { path: '/stock-profit', icon: FaBalanceScale, label: 'Stock Profit/Loss' },
    { path: '/cagr', icon: FaChartLine, label: 'CAGR Calculator' },
    { path: '/dividend-yield', icon: FaCoins, label: 'Dividend Yield' },
    { path: '/stock-average', icon: FaLayerGroup, label: 'Stock Average' },
    { path: '/mf-returns', icon: FaChartPie, label: 'MF Returns' },
  ] },
];